import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Select, SelectContent, SelectItem, SelectTrigger } from "@/components/ui/select";
import { StageBadge } from "@/components/Badges";
import { api, inr, STAGE, fmtDate, formatErr } from "@/lib/api";

export default function Leads() {
  const [leads, setLeads] = useState([]);
  const load = () => api.get("/leads").then((r) => setLeads(r.data));
  useEffect(() => {
    load();
  }, []);

  const move = async (id, stage) => {
    try {
      await api.put(`/leads/${id}`, { stage });
      toast.success(`Moved to ${STAGE[stage]}`);
      load();
    } catch (e) {
      toast.error(formatErr(e));
    }
  };

  return (
    <div className="space-y-5">
      <div>
        <h1 className="font-heading text-4xl font-extrabold text-slate-900 tracking-tight">Sales Pipeline</h1>
        <p className="text-sm text-slate-500 mt-1">All leads captured by the sales team across Varanasi and nearby districts.</p>
      </div>
      <div className="grid grid-flow-col auto-cols-[minmax(260px,1fr)] gap-4 overflow-x-auto pb-2" data-testid="pipeline-board">
        {Object.keys(STAGE).map((s) => {
          const col = leads.filter((l) => l.stage === s);
          return (
            <div key={s} className="bg-slate-100 rounded-2xl p-3" data-testid={`pipeline-col-${s}`}>
              <div className="flex items-center justify-between px-1 mb-3">
                <StageBadge stage={s} />
                <span className="text-xs font-mono-num text-slate-600">{inr(col.reduce((a, l) => a + (l.estimated_deal_value || 0), 0))}</span>
              </div>
              <div className="space-y-2">
                {col.map((l) => (
                  <div key={l.id} className="bg-white rounded-xl border p-3" data-testid={`pipeline-lead-${l.id}`}>
                    <div className="font-semibold text-sm text-slate-900">{l.hospital_name}</div>
                    <div className="text-xs text-slate-500 mt-0.5">{l.equipment_inquired}</div>
                    <div className="font-mono-num font-semibold text-sm mt-2">{inr(l.estimated_deal_value)}</div>
                    <div className="text-[11px] text-slate-500 mt-1">{l.city} · {l.created_by_name} · F/U {fmtDate(l.follow_up_date)}</div>
                    <Select value={l.stage} onValueChange={(v) => move(l.id, v)}>
                      <SelectTrigger className="h-7 text-xs mt-2" data-testid={`admin-lead-stage-${l.id}`}>Move stage</SelectTrigger>
                      <SelectContent className="bg-white">{Object.entries(STAGE).map(([k, v]) => <SelectItem key={k} value={k}>{v}</SelectItem>)}</SelectContent>
                    </Select>
                  </div>
                ))}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
